const translations = {
  'dates&fees.seo.title': 'TEFL Course Dates in Barcelona | 2025 TESOL Courses',
  'dates&fees.seo.description': `Find out more about TEFL Iberia's course dates and fees in Barcelona – and apply to become a student online.`,
  'dates&fees.sec1.title': 'Dates & Fees',
  'dates&fees.sec2.title': 'TEFL Course Prices 2026',
  'dates&fees.sec2.optionalExtras': 'Optional Extras',
  'dates&fees.sec2.price': 'PRICE',
  'dates&fees.sec2.accInBarcelona': '4 Weeks Accommodation in Barcelona',
  'dates&fees.sec2.accInSevillie': '4 Weeks Accommodation in Seville',
  'dates&fees.sec2.airportPickUp': 'Airport pick up',
  'dates&fees.sec2.culturalActivity': 'Cultural activity',
  'dates&fees.sec2.nie': 'NIE Appointment and Assistance',
  'dates&fees.sec2.service': 'Empadronamiento service',
  'dates&fees.sec2.teachingYL': 'Teaching Young Learners Extension Course',
  'dates&fees.sec3.title': 'Course Payment',
  'dates&fees.sec3.benefit1': '500€ downpayment to secure your place.',
  'dates&fees.sec3.benefit2':
    'Discount prices apply when you pay for the course in full when you sign up.',
  'dates&fees.sec3.benefit3':
    'Read more about our <accentedLink> flexible payment plan. </accentedLink>',
  'dates&fees.sec3.description':
    ' You can pay for your course using a credit/debit card, cash, Transferwise or direct bank transfer. Once you have applied and been accepted onto the course you will be provided with a link in order to complete the payment. <accentedLink > Please read our refund policy.</accentedLink>',
  'dates&fees.cs.title': 'Barcelona TEFL Course Dates',
  'dates&fees.cs.barcelona': 'Barcelona',
  'dates&fees.cs.sevillie': 'Seville',
};

export default translations;
